<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">门店账户</span>
      <p v-if="renewalOrderEntrance" class="review-renewal-order" @click="reviewRenewalOrder">查询续费订单</p>
    </h2>
    <div class="list-content">
      <serviceDisplay />
    </div>
  </div>
</template>
<script>
import serviceDisplay from './components/serviceDisplay.vue';
import { mapGetters, mapActions, mapState } from 'vuex';
// import direction from '../../../components/global/direction/index';
import Constant, { STORE_TYPE } from '@/lib/constant';
import { hasPermission } from '@/util';

export default {
  data() {
    return {
      ...STORE_TYPE
    };
  },
  components: { serviceDisplay },
  computed: {
    ...mapState('global', ['userInfo', 'isChain']),
    ...mapState('renewal', ['renewalOrderEntrance']),
    rechargeShow() {
      const { storeType, isRenewal } = this.storeAccoutnInfo;
      // 后端告知需要年费续费，就不展示储值续费  新的产品需求，储值用户也有可能展示年费续费，具体逻辑在后端
      if (isRenewal) return false;
      // 只有店长及储值店铺有储值权限
      return hasPermission([Constant.RoleList.d]) && [STORE_TYPE.STORED_VALUE, STORE_TYPE.REGULAR].includes(storeType);
    }
  },
  mounted() {
    // this.$store.dispatch('global/SETstoreAccoutnInfo');
    // this.hasUnpaidOrder('monomer');
    // this.hasRenewalOrderEntrance();
  },
  methods: {
    ...mapActions('renewal', ['hasUnpaidOrder', 'submitRenewalOrder', 'hasRenewalOrderEntrance']),
    onSubmit(data) {
      const { storeId } = this.storeAccoutnInfo;
      this.submitRenewalOrder({ ...data, storeIdList: [storeId], prefixes: 'monomer' });
    },
    reviewRenewalOrder() {
      this.$router.push('monomer_renewalOrderList');
    }
  }
};
</script>

<style lang="scss" scoped>
.title-area {
  display: flex;
  justify-content: space-between;
  .review-renewal-order {
    width: 104px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #f2f2f2;
  }
}
.list-content {
  padding-bottom: 50px;
}
</style>
